import { Component, Input } from '@angular/core';
import { DatasourceService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';


@Component({
  selector: 'images-scrollview',
  template: `
    <!--{{ items | json}}-->
    <kendo-scrollview [data]="items" [width]="witdh" [height]="height" [arrows]="items.length" [pageable]="items.length" style="margin-top: 14px;">
        <ng-template let-item="item">
            <img width="100%" src='{{item.photo}}'/>
        </ng-template>
    </kendo-scrollview>`, 
  styles: [
    ``
  ] 
})
export class ImagesScrollviewComponent {  

  //Input: width
  @Input() width = '100%';

  //Input: height
  @Input() height = '190px';

  //Input: id
  protected _id : number = 0;  

  @Input()
  set id(value: number) {
    this._id = value;
    // this.debug('set table = ' + this._table);

    let state : State = {
        skip: 0, 
        take: 0, 
        // sort: [{field: 'sku_exp', dir: 'desc'}], 
        filter: {
          logic: "and",
          filters: [
              {
                  field: 'id_vehicle_inventory',
                  operator: 'eq',
                  value: this._id
              }
          ]
        }, 
        group: []
      }

      this.service.get('vehicles_inventories_photos', state)
        .subscribe(
          (res) => {
            // console.log("RESPONSE------: ", res);
            this.items = res.data;            
          },
          (fail) => {        
            console.log("Error", fail);
          }
        );

  }

  get id(): number { return this._id; }

  protected items: any[] = [];

  constructor(protected service: DatasourceService) {
      
  }

}
